import { ICause } from '../containers/SelectCausePage/SelectCausePage';

type OneSearchDataItem = {
  Name: string;
  Id: number;
  Logo: string;
  Type: string;
  EventDate: string | null;
  Score: number;
  CampaignGuid: string | null;
  CharityId: number;
};

type OneSearchResults = {
  Title: string;
  Results: OneSearchDataItem[];
};

type OneSearchData = {
  GroupedResults: OneSearchResults[];
};

type OneSearchDataTransformItemType = ICause;

export type oneSearchDataTransformType = OneSearchDataTransformItemType[];

export default (results: OneSearchData): oneSearchDataTransformType => {
  const { GroupedResults } = results;
  let transformed: OneSearchDataTransformItemType[] = [];

  function extractData(data: OneSearchDataItem) {
    const {
      Name,
      Id,
      Logo,
      Type,
      EventDate,
      Score,
      CampaignGuid,
      CharityId,
    } = data;
    return {
      name: Name,
      id: Type === 'Campaign' ? CharityId : Id,
      logo: Logo,
      type: Type,
      eventdate: EventDate,
      score: Score,
      campaignGuid: CampaignGuid,
    };
  }

  GroupedResults.forEach((array: OneSearchResults) => {
    transformed = [...array.Results.map(extractData), ...transformed];
  });

  return transformed.sort(
    (
      ScoreA: OneSearchDataTransformItemType,
      ScoreB: OneSearchDataTransformItemType,
    ) => ScoreB.score - ScoreA.score,
  );
};
